const IntlMessageFormat = require('intl-messageformat');
const appOptions = require('helpers/appOptions');
/*
    read -
        Given a template, and variables, it will generate the combined string.
        It supports both passing in a list of values, or a map.
        Because there are currently Lingua values that are in these formats,
        this function must support them.

    Paramters:
        Translation - The lingua value, or string.
        'My Linga Value {0}'
        'My branch {1} Linga Value {0}'
        'Hello: {NAME}, welcome to {BRAND}'

    Example Uses:
    read('My Linga Value {0}', '5') =>  'My Lingua Value 5'
    read('My branch {1} Linga Value {0}', 'foo', 'bar') => 'My branch foo Linga Value bar'
    read('Hello: {NAME}, welcome to {BRAND}', {NAME: 'Phil', BRAND: 'HomeAway'}) => 'Hello: Phil, welcome to HomeAway'

    Note that this was shamelessly stolen from the labelMaker implementation in PDP.
*/

function read(key = '???', ...args) {
    let formattedMessage = '';
    let valueMap = args;
    let i = 0;

    // Unlike PDP where by the time this code is called the translation
    // is resolved, we'll need to look up the key ourselves and swap it for the
    // translation on the fly. You can see how the files will look by looking in
    // build/tranlastions after doing a build.
    const locale = appOptions.get('locale');
    const translation =
        window.i18n && window.i18n[locale] && window.i18n[locale][key];
    if (!translation) {
        return key;
    }

    if (Array.isArray(args) && args.length) {
        if (args.length === 1 && typeof args[0] === 'object') {
            valueMap = args[0];
        } else {
            valueMap = {};
            for (i; i < args.length; i++) {
                valueMap[i] = args[i];
            }
        }
    } else {
        return translation;
    }

    try {
        let intlMessageFormat = new IntlMessageFormat(translation);
        formattedMessage = intlMessageFormat.format(valueMap);
    } catch (e) {
        return translation;
    }
    return formattedMessage;
}

function exists(key) {
    const locale = appOptions.get('locale');
    return !!window.i18n && window.i18n[locale] && window.i18n[locale][key];
}

module.exports = {read, exists};
